import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesError() {
	const context = useContext(AppSettings);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="error-page">
			<div className="error-page-content">
				<div className="error-code">404</div>
				
				<h1 className="mb-3">Oops!</h1> 
				<h3 className="mb-2">We can't seem to find the page you're looking for</h3>
				<p className="mb-2">
					Here are some helpful links instead:
				</p>
				<p className="mb-5">
					<Link to="/" className="text-decoration-none">Home</Link>
					<span className="link-divider"></span>
					<Link to="/page/search-results" className="text-decoration-none">Search</Link>
					<span className="link-divider"></span>
					<Link to="/email/inbox" className="text-decoration-none">Email</Link>
					<span className="link-divider"></span>
					<Link to="/calendar" className="text-decoration-none">Calendar</Link>
					<span className="link-divider"></span>
					<Link to="/settings" className="text-decoration-none">Settings</Link>
					<span className="link-divider"></span>
					<Link to="/helper" className="text-decoration-none">Helper</Link>
				</p>
				<Link to="/" className="btn btn-theme w-130px text-uppercase btn-sm py-2 fs-11px">Go to Homepage</Link>
			</div>
		</div>
	)
}

export default PagesError;